import React, { Component } from 'react';
import { makeStyles } from '@mui/styles';
import {Paper, Tabs, Tab, Typography, Box, Container, Button, Dialog, DialogTitle, DialogContent, IconButton} from '@mui/material';
import { Link } from 'react-router-dom';
import Global from "../../customlib/Global";
import TeleFuReport from '../ContactLeadsReport/TeleFuReport';
import TeleChatByCustomer from '../ContactLeadsReport/TeleChatByCustomer';
import EventReminderReport from '../ContactLeadsReport/EventReminderReport';
import TeleResponseTimeReportAverage from '../SalesResponseTimeReport/TeleResponseTimeReportAverage';
import TeleDiChatCustomerResponseTimeReportAverage from '../SalesResponseTimeReport/TeleDiChatCustomerResponseTimeReportAverage';
import TeleFuEffectivityRate from '../SalesResponseTimeReport/TeleFuEffectivityRate';
import TeleFuHsmMarketingEffectivityRate from '../SalesResponseTimeReport/TeleFuHsmMarketingEffectivityRate';
import HsmTeleEffectivityRate from '../SalesResponseTimeReport/HsmTeleEffectivityRate';
import ResumeKedisiplinanFuTele from '../KedisiplinanFuTele/ResumeKedisiplinanFuTele';
import DetailKedisiplinanFuTele from '../KedisiplinanFuTele/DetailKedisiplinanFuTele';
import { ArrowBack, ChevronLeft, ChevronRight, Close, Settings, Warning } from '@mui/icons-material';
import TeleDiChatOlehCustomerResponseTimeReportFirstTime from '../SalesResponseTimeReport/TeleDiChatOlehCustomerResponseTimeReportFirstTime';
import TeleDataPendingDashboard from '../TeleDataPendingDashboard';
import TeamLeader from '../TeamLeader';
import TeleChatByCustomerCancel from '../FiveWhysTele/TeleChatByCustomerCancel';
import FiveWhyDashboard from '../FiveWhysTele';
import DashboardBlast from '../ContactLeadsReport/DashboardBlast';
import AutoReplyTele from './AutoReplyTele';
// import TeleChatByCustomerCancel from '../ContactLeadsReport/TeleChatByCustomerCancel';
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

class DashboardTele extends Component {

    state = {
        value : 0,
        showAutoReplyTele: false,
    }

    useStyles = makeStyles({
        root: {
          flexGrow: 1
        },
      });

    // classes = useStyles();
    // const [value, setValue] = React.useState(0);

    componentDidMount() {
        this.setState({value: 0});
    }
    

    handleChange = (event, newValue) => {
        // setValue(newValue);
        this.setState({value:newValue});
    };

    toggleShowAutoReplyTele = () => {
        this.setState({showAutoReplyTele: !this.state.showAutoReplyTele});
    }

    isAllow = () => {
        return Global.get.admin || 
            Global.isTeleAdmin() || Global.isTeleCutomer() || Global.isTeleUser() ||
            Global.isAdminTeleUser || Global.isAdminEpUser();
    }

    render() { 
        return ( 
            <>
            <Paper className={this.useStyles.root} style={{margin: "10px", padding: "5px", backgroundColor: "#e7eef4"}}>
                <div className="container-fluid text-center">
                  <div className="row">
                      <div className="col-8 text-left" style={{paddingLeft: "30px"}}><h4>Dashboard Tele</h4></div>
                      <div className="col-3 text-right">
                          <Button sx={{textTransform: "capitalize"}} fullWidth variant='contained' color='primary' startIcon={<Settings />} onClick={this.toggleShowAutoReplyTele}>Auto Reply Settings</Button>
                      </div>
                      <div className="col-1 text-right">
                          <Link to="/">
                              <div className="btn btn-danger">X</div>
                          </Link>
                      </div>
                  </div>
                </div>
                
            </Paper>
            {
                !this.isAllow() ? (
                    <Box sx={{width: "100%",margin: "20px", border: "solid 0px"}}>
                        <Box textAlign={"center"}>
                            <Warning color='error' />
                            <h4>Halaman ini bukan untuk Anda</h4>
                            <Link to="/"><ChevronLeft /> Kembali</Link>
                        </Box>
                    </Box>
                ) : 
                (
                    // <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: "100%" }}>
                    <Box>
                        <Tabs
                            value={this.state.value}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            // centered
                            variant='scrollable'
                            orientation='horizontal'
                            // sx={{ borderRight: 1, borderColor: 'divider', maxWidth:"150px", fontSize: "10px" }}
                            sx={{ borderRight: 1, borderColor: 'divider', width: "100%", fontSize: "10px" }}
                            // visibleScrollbar
                        >
                            <Tab sx={{fontSize: "10px"}} key="tab0" label="FU Report" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab1" label="Di Chat Customer" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab2" label="Di Chat Customer - Cancel" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab3" label="Data Pending" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab4" label="ER Report" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab5" label="Avrage Tele/Recycle" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab6" label="First Respon Dichat Customer" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab7" label="Average Dichat Customer" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab8" label="Efektivitas FU" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab9" label="Efektivitas FU HSM Marketing" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab10" label="Efektivitas HSM" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab11" label="Kedisiplinan FU" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab12" label="Resume Kedisiplinan FU" wrapped />
                            {Global.get().admin && <Tab sx={{fontSize: "10px"}} key="tab13" label="Team" wrapped />}
                            <Tab sx={{fontSize: "10px"}} key="tab14" label="5 Why" wrapped />
                            <Tab sx={{fontSize: "10px"}} key="tab4" label="Dashboard Blast" wrapped />
                            {/* <Tab key="tab2" label="Cancel By Jam" wrapped /> */}
                        </Tabs>
                        <TabPanel value={this.state.value} index={0} style={{width: "100%"}}>
                            <TeleFuReport />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={1} style={{width: "100%"}}>
                            <TeleChatByCustomer />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={2} style={{width: "100%"}}>
                            <TeleChatByCustomerCancel />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={3} style={{width: "100%"}}>
                            <TeleDataPendingDashboard />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={4} style={{width: "100%"}}>
                            <EventReminderReport />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={5} style={{width: "100%"}}>
                            <TeleResponseTimeReportAverage />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={6} style={{width: "100%"}}>
                            <TeleDiChatOlehCustomerResponseTimeReportFirstTime />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={7} style={{width: "100%"}}>
                            <TeleDiChatCustomerResponseTimeReportAverage />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={8} style={{width: "100%"}}>
                            <TeleFuEffectivityRate />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={9} style={{width: "100%"}}>
                            <TeleFuHsmMarketingEffectivityRate />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={10} style={{width: "100%"}}>
                            <HsmTeleEffectivityRate />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={11} style={{width: "100%"}}>
                            <DetailKedisiplinanFuTele />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={12} style={{width: "100%"}}>
                            <ResumeKedisiplinanFuTele />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={13} style={{width: "100%"}}>
                            <TeamLeader defaultType={"TELEMARKETING"} standAlone={true}/>
                        </TabPanel>
                        <TabPanel value={this.state.value} index={14} style={{width: "100%"}}>
                            <FiveWhyDashboard />
                        </TabPanel>
                        <TabPanel value={this.state.value} index={15} style={{width: "100%"}}>
                            <DashboardBlast />
                        </TabPanel>
                    </Box>
                )
            }
            <Dialog fullScreen open={this.state.showAutoReplyTele} onClose={this.toggleShowAutoReplyTele}>
                <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    Auto Reply Settings
                    <IconButton onClick={this.toggleShowAutoReplyTele}><Close /></IconButton>
                </DialogTitle>
                <DialogContent>
                    <AutoReplyTele onClose={this.toggleShowAutoReplyTele} />
                </DialogContent>
            </Dialog>
            </>
         );
    }
}
 
export default DashboardTele;